/**
 * Lecture de la réponse POST de création d'un partenaire
 * (resources/users.py + services/partner_accounts/s3_contract_folder.py).
 */

const LOCALE_ORDER = ['fr_FR', 'en_US'];

export const PARTNER_CONTRACT_LOCALE_LABELS = {
    fr_FR: 'Français',
    en_US: 'Anglais',
};

const AWS_CONSOLE_URL_PATTERN = /^https:\/\/([a-z0-9-]+\.)?console\.aws\.amazon\.com\//i;

/** URL navigable de la console AWS uniquement (rejette `s3://…`, chaînes vides, autres domaines). */
export const isAwsConsoleUrl = (value) => (
    typeof value === 'string' && AWS_CONSOLE_URL_PATTERN.test(value.trim())
);

const getS3Folder = (result) => (result?.s3_folder && typeof result.s3_folder === 'object' ? result.s3_folder : {});

export const getPartnerName = (result) => (
    result?.partner?.company_name
    || getS3Folder(result).company_label
    || ''
);

/** `s3_console_url` fourni par le backend, ou null s'il est absent / invalide. */
export const getPartnerS3ConsoleUrl = (result) => {
    const candidate = result?.s3_console_url || getS3Folder(result).s3_console_url;
    return isAwsConsoleUrl(candidate) ? candidate.trim() : null;
};

export const getPartnerS3Info = (result) => {
    const folder = getS3Folder(result);
    return {
        label: folder.company_label || '',
        bucket: result?.s3_bucket || folder.bucket || '',
        prefix: result?.s3_prefix || folder.prefix || '',
        uri: folder.s3_uri || result?.contract_doc_s3_link || '',
    };
};

/**
 * Documents attendus groupés par langue, à partir de `contract_doc_s3_folders`.
 * Repli : `s3_folder.expected_documents` (groupe unique, sans langue).
 */
export const getPartnerDocumentGroups = (result) => {
    const folders = result?.contract_doc_s3_folders || getS3Folder(result).contract_doc_s3_folders;
    if (folders && typeof folders === 'object') {
        const locales = [
            ...LOCALE_ORDER.filter((locale) => folders[locale]),
            ...Object.keys(folders).filter((locale) => !LOCALE_ORDER.includes(locale)),
        ];
        const groups = locales
            .map((locale) => {
                const folder = folders[locale] || {};
                return {
                    locale,
                    label: PARTNER_CONTRACT_LOCALE_LABELS[locale] || locale,
                    consoleUrl: isAwsConsoleUrl(folder.s3_console_url) ? folder.s3_console_url.trim() : null,
                    documents: Array.isArray(folder.documents) ? folder.documents.filter(Boolean) : [],
                };
            })
            .filter((group) => group.documents.length > 0);
        if (groups.length > 0) return groups;
    }

    const expected = getS3Folder(result).expected_documents;
    if (Array.isArray(expected) && expected.length > 0) {
        return [{ locale: null, label: null, consoleUrl: null, documents: expected.filter(Boolean) }];
    }
    return [];
};

export const getDocumentFileType = (fileName) => {
    const extension = String(fileName || '').split('.').pop().toLowerCase();
    if (extension === 'pdf') return 'pdf';
    if (extension === 'docx' || extension === 'doc') return 'docx';
    return 'other';
};
